const { isValid } = require('./utils/isValid')
const { getParts } = require('./utils/getParts')
const { gt } = require('./utils/gt')
const { gte } = require('./utils/gte')
const { coerce } = require('./utils/coerce')

const Semver = {
  isValid,
  getParts,
  gt,
  gte,
  coerce
}

module.exports.Semver = Semver
